export default {
  name: 'newHazard',
  miniSave: true,
  uploadFunction: ({ requestFunction, data, saveId }) => {
    const controls = Array.isArray(data.hazardData.controls)
      ? data.hazardData.controls
      : data.hazardData.controlid !== null && data.hazardData.controlid !== undefined
      ? [data.hazardData.controlid]
      : []

    const payload = {
      hazardData: {
        ...data.hazardData,
        controlid: controls.length > 0 ? controls[0] : null,
        controls,
      },
      siteid: data.siteid,
    }

    return requestFunction
      .methodRequest(`/hazards/view/${data.hazardidId}/addhazard`, 'PUT', payload)
  },
  restoreSave: (ctx) => {
  }
}
